webpackJsonp([142629428675168],{

/***/ 1418:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Czech Milk","languages":{"defaultLangKey":"en","langs":["cs","en","fr"]}}}},"pathContext":{"slug":"/","langKey":"en"}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-45ca3cde5d68c1ac78cf.js